import { ChallengeOverview } from "../components/overview/ChallengeOverview.fetcher";

const ChallengeOverviewPage = ChallengeOverview;
export default ChallengeOverviewPage;
